import { DeviceType } from '../../../users/types';

export enum CreateDeviceActions {
  CREATE_DEVICE_REQUEST = 'CREATE_DEVICE_REQUEST',
  CREATE_DEVICE_SUCCEEDED = 'CREATE_DEVICE_SUCCEEDED',
  CREATE_DEVICE_FAILED = 'CREATE_DEVICE_FAILED',

  SET_GEOLOCATION = 'SET_GEOLOCATION',
  SET_DEVICE_DATA = 'SET_DEVICE_DATA',
  DELETE_DEVICE_DATA = 'DELETE_DEVICE_DATA',
  // Для popup
  SHOW_LOCATION_POPUP = 'SHOW_LOCATION_POPUP',
  HIDE_LOCATION_POPUP = 'HIDE_LOCATION_POPUP',
  SET_CLICKED_ADDRESS = 'SET_CLICKED_ADDRESS',
  SHOW_DISTANCE_ERROR = 'SHOW_DISTANCE_ERROR',

  // Для модалки
  OPEN_CREATE_MODAL = 'OPEN_CREATE_MODAL',
  CLOSE_CREATE_MODAL = 'CLOSE_CREATE_MODAL',

  ON_ORGANIZATION_CHANGE = 'ON_CHANGE_ORGANIZATION',
  ON_ADDRESS_CHANGE = 'ON_CHANGE_ADDRESS',
  ON_NOTES_CHANGE = 'ON_CHANGE_NOTES',
}
export interface CreateDeviceInput {
  address: string;
  location: {
    lat: number;
    lon: number;
  };
  notes: string;
  organization: string;
  deviceType: DeviceType.DEVICE;
  userLocation?: {
    lat: number;
    lon: number;
  };
}

export interface Device {
  id: string;
  __typename: string;
  address: string;
  approvalsCount: number;
  location: {
    lat: number;
    lon: number;
  };
  notes: string;
  organization: string;
  registrationDate: string;
  status: string;
  user: {
    id: string;
  };
}

export type Location = {
  lat: number;
  lon: number;
};

export type CreateDeviceRequest = {
  type: CreateDeviceActions.CREATE_DEVICE_REQUEST;
  input: CreateDeviceInput;
};

export type SetGeolocation = {
  type: CreateDeviceActions.SET_GEOLOCATION;
  userLocation: Location;
};

export type OpenCreateModal = {
  type: CreateDeviceActions.OPEN_CREATE_MODAL;
  deviceLocation: Location;
  address: string;
};

export type CloseCreateModal = {
  type: CreateDeviceActions.CLOSE_CREATE_MODAL;
};

export type ShowLocationPopUp = {
  type: CreateDeviceActions.SHOW_LOCATION_POPUP;
  deviceLocation: Location;
  address: string;
};

export type HideLocationPopUp = {
  type: CreateDeviceActions.HIDE_LOCATION_POPUP;
};

export type OnOrganizationChange = {
  type: CreateDeviceActions.ON_ORGANIZATION_CHANGE;
  organization: string;
};

export type OnAddressChange = {
  type: CreateDeviceActions.ON_ADDRESS_CHANGE;
  address: string;
};

export type OnNotesChange = {
  type: CreateDeviceActions.ON_NOTES_CHANGE;
  notes: string;
};

export type ShowDistanceError = {
  type: CreateDeviceActions.SHOW_DISTANCE_ERROR;
};

export type CreateDeviceSucceeded = {
  type: CreateDeviceActions.CREATE_DEVICE_SUCCEEDED;
  createdDeviceResponseData: object;
};

export type CreateDeviceFailed = {
  type: CreateDeviceActions.CREATE_DEVICE_FAILED;
  errorMessage: string;
};

export type CreateDeviceActionsType =
  | CreateDeviceRequest
  | SetGeolocation
  | OpenCreateModal
  | CloseCreateModal
  | ShowLocationPopUp
  | HideLocationPopUp
  | OnOrganizationChange
  | OnAddressChange
  | OnNotesChange
  | ShowDistanceError
  | CreateDeviceSucceeded
  | CreateDeviceFailed;

export const createDeviceRequest = (input: any): CreateDeviceRequest => ({
  type: CreateDeviceActions.CREATE_DEVICE_REQUEST,
  input,
});

export const createDeviceSucceeded = (createdDeviceResponseData: object): CreateDeviceSucceeded => ({
  type: CreateDeviceActions.CREATE_DEVICE_SUCCEEDED,
  createdDeviceResponseData,
});

export const createDeviceFailed = (errorMessage: string): CreateDeviceFailed => ({
  type: CreateDeviceActions.CREATE_DEVICE_FAILED,
  errorMessage,
});

export const setGeolocation = (userLocation: Location): SetGeolocation => ({
  type: CreateDeviceActions.SET_GEOLOCATION,
  userLocation,
});

export const openCreateModal = (deviceLocation: Location, address: string): OpenCreateModal => ({
  type: CreateDeviceActions.OPEN_CREATE_MODAL,
  deviceLocation,
  address,
});

export const closeCreateModal = (): CloseCreateModal => ({
  type: CreateDeviceActions.CLOSE_CREATE_MODAL,
});

export const showLocationPopUp = (deviceLocation: Location, address: string): ShowLocationPopUp => ({
  type: CreateDeviceActions.SHOW_LOCATION_POPUP,
  deviceLocation,
  address,
});

export const hideLocationPopUp = (): HideLocationPopUp => ({
  type: CreateDeviceActions.HIDE_LOCATION_POPUP,
});

export const onOrganizationChange = (organization: string): OnOrganizationChange => ({
  type: CreateDeviceActions.ON_ORGANIZATION_CHANGE,
  organization,
});

export const onAddressChange = (address: string): OnAddressChange => ({
  type: CreateDeviceActions.ON_ADDRESS_CHANGE,
  address,
});

export const onNotesChange = (notes: string): OnNotesChange => ({
  type: CreateDeviceActions.ON_NOTES_CHANGE,
  notes,
});

export const showDistanceError = (): ShowDistanceError => ({
  type: CreateDeviceActions.SHOW_DISTANCE_ERROR,
});
